module.exports = __webpack_public_path__ + "static/media/alarm_beeps.9840be64.mp3";